import { useEffect } from "react";
import { Link } from "react-router-dom";
import SubMenu from "../subMenu/subMenu";
import { ReactComponent as BurgMenu } from "../../assets/icons/burg-menu.svg";
import "./navbar.css";

const Navbar = ({
  linkList,
  iconClickImp,
  linkClickImp,
  menuIcon,
  subClick,
}) => {
  // Sets expanded menus to display none at the initial render
  useEffect(() => {
    let setNavDisplay = document.querySelectorAll(".nav-menu");
    let mql = window.matchMedia(`(max-width: ${1024}px)`);

    if (mql.matches) {
      setNavDisplay.forEach((element) => {
        element.classList.add("display-none");
      });
    } else {
      setNavDisplay.forEach((element) => {
        element.classList.remove("display-none");
      });
    }

    window.addEventListener("resize", () => {
      if (mql.matches) {
        setNavDisplay.forEach((element) => {
          element.classList.add("display-none");
        });
      } else {
        setNavDisplay.forEach((element) => {
          element.classList.remove("display-none");
        });
      }
    });
  });

  // Triggered on menu icon click
  const iconClick = (evt) => {
    const container = evt.target.closest(".nav-container");
    if (iconClickImp) {
      iconClickImp(container, ".nav-menu");
    }
  };

  // Triggered when list item is clicked
  const linkClick = (evt) => {
    const container = evt.target.closest(".nav-container");
    if (linkClickImp) {
      linkClickImp(container, ".nav-menu");
    }
  };

  return (
    <nav className="nav-container">
      <BurgMenu
        width="20"
        height="20"
        className="menu-icon"
        alt="navigation"
        onClick={(e) => iconClick(e)}
      />
      <ul className="nav-menu">
        {linkList.map((element, index) => {
          if (element.type === "link") {
            return (
              <li key={`${element}${index}`}>
                <Link
                  to={`${element.link}`}
                  onClick={(e) => {
                    linkClick(e);
                    if (element.function) element.function();
                  }}
                >
                  {element.title}
                </Link>
              </li>
            );
          } else {
            return (
              <>
                <SubMenu
                  linkList={element.subMenu}
                  menuTitle={element.title}
                  menuClickImp={subClick}
                  linkClickImp={linkClick}
                />
              </>
            );
          }
        })}
      </ul>
    </nav>
  );
};

export default Navbar;
